import { forwardRef } from 'react';
import { BaseSplitButton } from './__internal__/BaseSplitButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const SplitButton = /*#__PURE__*/forwardRef(function SplitButton(props, ref) {
  return /*#__PURE__*/_jsx(BaseSplitButton, {
    ...props,
    ref: ref
  });
});
//# sourceMappingURL=SplitButton.js.map